import { useEffect } from "react";
import { handlerZoom } from "../functions/handlerZoom";

export default function useNoPassiveEventListener(ref, event, func, statusScroll, minScaleRef) {
  useEffect(() => {
    if (!ref.current) return;
    let eventListener = (e) => {
      // Legge il valore corrente del ref ad ogni evento, così è sempre aggiornato
      const minScale = minScaleRef?.current ?? 0.5;
      handlerZoom(e, func, statusScroll, minScale);
    };
    ref.current.addEventListener(event, eventListener, { passive: false });

    return () => {
      if (ref.current) {
        ref.current.removeEventListener(event, eventListener, { passive: false });
      }
    };
  }, [ref, event, func, statusScroll]);
  // Nota: minScaleRef è intenzionalmente escluso dalle dipendenze perché è un ref
  // (oggetto stabile) — il suo .current viene letto direttamente nell'handler.
}